<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Share in email </h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div>
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Enter email address</mat-label>
          <input [(ngModel)]="email" matInput>
        </mat-form-field>
      </div>
      <div>
        <p>If your customer is interested in receiving the invoice via email, add his/her email id if it's not appearing above automatically.</p>
      </div>

    </mat-dialog-content>
    
      
    <mat-dialog-actions align="end">
        <button
          mat-button
          mat-dialog-close
      
        >
          Cancel
        </button>
        <button
          (click)="shareViaEmail()"
          mat-flat-button
          color="accent"
          [disabled]="checkdis()"
          
        >
          Share invoice
        </button>
    
      </mat-dialog-actions>